module.exports = __webpack_public_path__ + "82205f579439430a2cc2727e67a2af6b.pdf";